<template>
  <button class="m-auto bg-purple-600 hover:bg-purple-500 text-white uppercase p-3 rounded-md">{{text}}</button>
</template>

<script>
export default {
  props:['text']
}
</script>
